<template>
  <div>
    <b-table-simple small responsive border fixed>
      <b-thead head-variant="danger">
        <b-tr>
          <b-th
            :colspan="cycleList.length > 0 ? cycleList.length : 3"
            class="text-center"
          >
            <span class="caption">
              {{
                egressProfile
                  ? egressProfileCycleSort.length > 1
                    ? String(
                        $t("matrix1.matrix1View.progressionOf") +
                          " " +
                          $getVisibleNames(
                            "mesh.competence",
                            true,
                            "Competencias"
                          )
                      )
                    : String(
                        $getVisibleNames(
                          "mesh.competence",
                          true,
                          "Competencias"
                        )
                      )
                  : String(
                      $getVisibleNames("mesh.competence", true, "Competencias")
                    )
              }}
              {{
                egressProfile
                  ? " " +
                    $t("reusable.common.of") +
                    " " +
                    egressProfile.professional_title
                  : ""
              }}
            </span>
            <br />
            <span v-if="career">{{ career.name.toUpperCase() }}</span>
            <span v-if="faculty"
              >,
              {{
                $getVisibleNames(
                  "mesh.faculty",
                  false,
                  "Facultad"
                ).toUpperCase()
              }}: {{ faculty.name.toUpperCase() }}</span
            >
          </b-th>
        </b-tr>
        <b-tr v-if="egressProfile">
          <b-th
            v-if="egressProfileCycleSort.length > 0"
            :colspan="cycleList.length > 0 ? cycleList.length : 3"
            style="
              background-color: var(--kl-color-accent-medium) !important;
              color: white !important;
            "
            class="text-center"
            >{{
              cycleList.length > 1
                ? $getVisibleNames(
                    "mesh.cycle",
                    true,
                    "Ciclos Formativos"
                  ).toUpperCase()
                : $getVisibleNames(
                    "mesh.cycle",
                    false,
                    "Ciclo Formativo"
                  ).toUpperCase()
            }}</b-th
          >
        </b-tr>
        <b-tr v-if="egressProfile">
          <template v-if="egressProfileCycleSort.length > 0">
            <b-th
              variant="secondary"
              class="text-center"
              v-for="cycle in egressProfileCycleSort"
              :key="cycle.id"
              :title="$htmlToPlainText(cycle.description)"
              >{{ cycle.name.toUpperCase() }}</b-th
            >
          </template>
          <template v-else>
            <!-- <b-th variant="secondary" colspan="3" class="text-center">
              {{
                $getVisibleNames(
                  "mesh.competence",
                  true,
                  "Competencias"
                ).toUpperCase()
              }}
            </b-th> -->
          </template>
        </b-tr>
      </b-thead>
      <b-tbody style="text-align: left">
        <template v-if="egressProfile">
          <template v-if="egressProfileCycleSort.length > 0">
            <b-tr
              v-for="(row, row_index) in competences_matrix"
              :key="row_index"
            >
              <b-td
                v-for="(competence, cell_index) in row"
                :key="cell_index"
                class="p-0 cycle-cell"
              >
                <div v-if="competence">
                  <!-- Competencias por ciclos -->
                  <template
                    v-for="(competence_list, competence_index) in competenceList
                      .filter(
                        (x) =>
                          x.egress_profile == competence.egress_profile &&
                          x.cycle == competence.cycle &&
                          x.order == competence.order
                      )
                      .sort((a, b) => a.sub_order - b.sub_order)"
                  >
                    <div
                      :class="{
                        'border-bottom':
                          competence_index + 1 <
                          competenceList.filter(
                            (x) =>
                              x.egress_profile == competence.egress_profile &&
                              x.cycle == competence.cycle &&
                              x.order == competence.order
                          ).length,
                      }"
                      :key="competence_list.id"
                    >
                      <div
                        style="text-align: justify"
                        class="mt-1 mx-1 mb-1"
                        :id="`competence-sentence-${competence_list.id}`"
                        :class="{
                          'mb-4':
                            competenceList.filter(
                              (x) =>
                                x.egress_profile == competence.egress_profile &&
                                x.cycle == competence.cycle &&
                                x.order == competence.order
                            ).length ==
                              competence_index + 1 && allows_crud,
                        }"
                      >
                        <SentenceContainer
                          style="padding-left: 12px; padding-top: 2px"
                          :Sentence="competence_list"
                        >
                          <template #order>
                            <strong class="mr-1">
                              {{ cell_index + 1 }}.{{ competence_list.order
                              }}<span
                                v-if="
                                  competence_list.sub_order > 0 &&
                                  institution &&
                                  institution.show_competence_sub_order
                                "
                                >.{{ competence_list.sub_order }}</span
                              >
                            </strong>
                          </template>
                        </SentenceContainer>
                        <div class="d-flex">
                          <div class="mr-0 ml-auto">
                            <template
                              v-if="institution && institution.show_base_ra"
                            >
                              <div
                                v-if="!isNaN(competence_list.competence)"
                                class="mr-1"
                              >
                                <h5
                                  :key="`ra-base-header-${competence_list.id}`"
                                  :id="`ra-base-header-${competence_list.id}`"
                                  v-bind:class="{
                                    'pointer-class':
                                      allows_crud &&
                                      ([
                                        'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                        'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                        'DIRECTIVOS FACULTAD O ESCUELA',
                                      ].some((group) =>
                                        user.group_names.includes(group)
                                      ) ||
                                        user.is_superuser ||
                                        $hasObjectPermission(
                                          'mesh.egressprofile',
                                          'change',
                                          egressProfile.id
                                        )),
                                  }"
                                  @click="
                                    () => {
                                      if (
                                        allows_crud &&
                                        ([
                                          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                          'DIRECTIVOS FACULTAD O ESCUELA',
                                        ].some((group) =>
                                          user.group_names.includes(group)
                                        ) ||
                                          user.is_superuser ||
                                          $hasObjectPermission(
                                            'mesh.egressprofile',
                                            'change',
                                            egressProfile.id
                                          ))
                                      )
                                        $bvModal.show(
                                          `modal-base-ra-${competence_list.id}`
                                        );
                                    }
                                  "
                                >
                                  <b-badge
                                    class="class-badge"
                                    variant="secondary"
                                    >{{
                                      raBasesFiltered(
                                        competence_list.competence
                                      ).length
                                    }}</b-badge
                                  >
                                </h5>
                                <b-modal
                                  :id="`modal-base-ra-${competence_list.id}`"
                                  hide-footer
                                  :title="
                                    $getVisibleNames(
                                      'teaching.basera',
                                      false,
                                      'RA Base'
                                    )
                                  "
                                  size="lg"
                                >
                                  <RaBase
                                    :competence_id="competence_list.competence"
                                    :can_update="can_update"
                                    :can_delete="can_delete"
                                  ></RaBase>
                                </b-modal>
                                <b-popover
                                  :target="`ra-base-header-${competence_list.id}`"
                                  :key="`ra-base-tooltip-${competence_list.id}`"
                                  triggers="hover"
                                >
                                  <template #title>{{
                                    $getVisibleNames(
                                      "teaching.basera",
                                      false,
                                      "RA Base"
                                    )
                                  }}</template>
                                  <template
                                    v-if="
                                      raBasesFiltered(
                                        competence_list.competence
                                      ).length > 0
                                    "
                                  >
                                    <div class="ra-competences-container">
                                      <span
                                        v-for="ra in raBasesFiltered(
                                          competence_list.competence
                                        )"
                                        :key="ra.id"
                                      >
                                        <SentenceContainer :Sentence="ra">
                                        </SentenceContainer>
                                      </span>
                                    </div>
                                  </template>
                                  <template v-else>
                                    {{
                                      $t("matrix1.matrix1View.doesNotHaveAny")
                                    }}
                                    {{
                                      $getVisibleNames(
                                        "teaching.basera",
                                        false,
                                        "RA Base"
                                      )
                                    }}
                                    {{ $t("matrix1.matrix1View.created") }}
                                  </template>
                                </b-popover>
                              </div>
                            </template>
                            <ButtonSmall
                              v-can="'mesh.change_egressprofilecompetence'"
                              v-if="
                                !isNaN(competence_list.competence) &&
                                allows_crud &&
                                can_update
                              "
                              :click_button="
                                () => askForUpdateCompetence(competence_list)
                              "
                              :tooltip_text="$t('reusable.common.edit')"
                              :icon="'square'"
                            ></ButtonSmall>
                            <ButtonSmall
                              v-can="'mesh.delete_egressprofilecompetence'"
                              v-if="
                                !isNaN(competence_list.id) &&
                                cell_index < row.length - 1 &&
                                allows_crud &&
                                can_delete
                              "
                              :click_button="
                                () => askForDeleteCompetence(competence_list.id)
                              "
                              :tooltip_text="$t('reusable.common.delete')"
                              :icon="'trash'"
                            ></ButtonSmall>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div class="float-button">
                    <ButtonSmall
                      v-can="'mesh.add_egressprofilecompetence'"
                      v-if="
                        ((institution &&
                          institution.show_competence_sub_order &&
                          cell_index < row.length - 1) ||
                          isNaN(competence.competence)) &&
                        allows_crud &&
                        can_update
                      "
                      :click_button="
                        () =>
                          askForUpdateCompetence({
                            egress_profile: competence.egress_profile,
                            action: '',
                            content: '',
                            condition: '',
                            sentence: '',
                            cycle: competence.cycle,
                            order: competence.order,
                            sub_order: getNextSubOrder(
                              competence.egress_profile,
                              competence.order,
                              competence.cycle
                            ),
                            type: competence.type,
                          })
                      "
                      :tooltip_text="``"
                      :icon="'plus'"
                      :custom_class="`mb-1`"
                    ></ButtonSmall>
                    <ButtonSmall
                      v-can="'mesh.add_egressprofilecompetence'"
                      v-if="
                        ((institution &&
                          institution.show_competence_sub_order &&
                          cell_index < row.length - 1) ||
                          isNaN(competence.competence)) &&
                        allows_crud &&
                        can_update &&
                        competence_precursors.some(
                          (x) =>
                            x.egress_profile_competence_order ==
                              competence.order &&
                            x.cycle == competence.cycle &&
                            x.has_entries
                        )
                      "
                      :click_button="
                        () =>
                          openSelectCompetenceModal({
                            egress_profile: competence.egress_profile,
                            cycle: competence.cycle,
                            order: competence.order,
                            sub_order: getNextSubOrder(
                              competence.egress_profile,
                              competence.order,
                              competence.cycle
                            ),
                            egress_profile_competence_id:
                              row[row.length - 1].id,
                          })
                      "
                      :tooltip_text="`${$t(
                        'reusable.common.selectLabel'
                      )} ${$getVisibleNames(
                        'mesh.competence',
                        true,
                        'Competencias'
                      )}`"
                      :icon="'filter-square'"
                      :custom_class="`mb-1 ml-2`"
                    ></ButtonSmall>
                    <!-- <button-add
                      v-can="'mesh.add_egressprofilecompetence'"
                      v-if="
                        ((institution &&
                          institution.show_competence_sub_order &&
                          cell_index < row.length - 1) ||
                          isNaN(competence.competence)) &&
                        allows_crud &&
                        can_update
                      "
                      @click="
                        askForUpdateCompetence({
                          egress_profile: competence.egress_profile,
                          action: '',
                          content: '',
                          condition: '',
                          sentence: '',
                          cycle: competence.cycle,
                          order: competence.order,
                          sub_order: getNextSubOrder(
                            competence.egress_profile,
                            competence.order,
                            competence.cycle
                          ),
                          type: competence.type,
                        })
                      "
                    ></button-add> -->
                  </div>
                  <b-tooltip
                    v-if="competenceCognitiveLevel(cell_index, row)"
                    :target="`competence-sentence-${competence.id}`"
                    variant="secondary"
                    style="z-index: 100"
                  >
                    <b-icon icon="exclamation-circle"></b-icon>
                    <span class="cognitive-level-tooltip">
                      {{
                        $t(
                          "matrix1.matrix1View.competenceBelongsToSuperiorLevel",
                          {
                            competence: $getVisibleNames(
                              "mesh.competence",
                              false,
                              "Competencia"
                            ),
                            cognitiveLevel: $getVisibleNames(
                              "mesh.cognitivelevel",
                              false,
                              "Nivel Cognitivo"
                            ).toLowerCase(),
                            cycle: $getVisibleNames(
                              "mesh.cycle",
                              false,
                              "Ciclo Formativo"
                            ),
                          }
                        )
                      }}
                    </span>
                  </b-tooltip>
                </div>
                <div v-else>-</div>
              </b-td>
            </b-tr>
            <!-- COMPETENCIAS SIN CICLOS -->
            <template
              v-if="competenceList.filter((x) => x.cycle == null).length > 0"
            >
              <b-tr>
                <b-th :colspan="cycleList.length > 0 ? cycleList.length : 3">
                  <div class="text-center">
                    {{
                      $getVisibleNames(
                        "mesh.competence",
                        false,
                        "Competencia"
                      ).toUpperCase()
                    }}
                    {{ $t("matrix1.matrix1View.without").toUpperCase() }}
                    {{
                      $getVisibleNames(
                        "mesh.cycle",
                        true,
                        "Ciclos Formativos"
                      ).toUpperCase()
                    }}
                    <InfoTooltip
                      class="noprint info-icon"
                      :tooltip_text="
                        $t('matrix1.matrix1View.competencesWithoutCyclesInfo', {
                          competences: $getVisibleNames(
                            'mesh.competence',
                            true,
                            'Competencias'
                          ),
                          egressProfile: $getVisibleNames(
                            'mesh.egressprofile',
                            false,
                            'Perfil de Egreso'
                          ),
                          cycle: $getVisibleNames(
                            'mesh.cycle',
                            false,
                            'Ciclo Formativo'
                          ),
                          matrix: $getVisibleNames(
                            'manual.matriz_3',
                            false,
                            'Matriz 3'
                          ),
                        })
                      "
                    >
                    </InfoTooltip>
                  </div>
                </b-th>
              </b-tr>
              <b-tr
                v-for="competence_type in competenceTypes"
                :key="competence_type.id"
              >
                <b-td
                  :colspan="cycleList.length > 0 ? cycleList.length : 3"
                  rowspan="1"
                  v-if="
                    competenceList.filter(
                      (x) => x.type == competence_type.id && x.cycle == null
                    ).length > 0
                  "
                >
                  <div
                    style="
                      background-color: var(--kl-color-accent-medium);
                      color: white;
                    "
                    class="text-center"
                  >
                    <strong
                      :title="$htmlToPlainText(competence_type.description)"
                      >{{ competence_type.name.toUpperCase() }}</strong
                    >
                  </div>
                  <div
                    class="pl-3"
                    v-for="competence in competenceList.filter(
                      (x) => x.type == competence_type.id && x.cycle == null
                    )"
                    :key="competence.id"
                  >
                    <b-row style="width: 100%; height: 100%">
                      <b-col>
                        <p>
                          <!-- <span style="position: absolute">{{
                            competence.order
                          }}</span> -->
                          <SentenceContainer :Sentence="competence">
                            <template #order>
                              <span class="mr-2">
                                {{ competence.order }}
                              </span>
                            </template>
                          </SentenceContainer>
                        </p>
                      </b-col>
                      <b-col cols="1">
                        <div class="button-wrap">
                          <div
                            class="mr-1"
                            v-if="institution && institution.show_base_ra"
                          >
                            <h5
                              :key="`ra-base-header-${competence.id}`"
                              :id="`ra-base-header-${competence.id}`"
                              v-bind:class="{
                                'pointer-class':
                                  allows_crud &&
                                  ([
                                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                    'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                    'DIRECTIVOS FACULTAD O ESCUELA',
                                  ].some((group) =>
                                    user.group_names.includes(group)
                                  ) ||
                                    user.is_superuser ||
                                    $hasObjectPermission(
                                      'mesh.egressprofile',
                                      'change',
                                      egressProfile.id
                                    )),
                              }"
                              @click="
                                () => {
                                  if (
                                    allows_crud &&
                                    ([
                                      'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                      'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                      'DIRECTIVOS FACULTAD O ESCUELA',
                                    ].some((group) =>
                                      user.group_names.includes(group)
                                    ) ||
                                      user.is_superuser ||
                                      $hasObjectPermission(
                                        'mesh.egressprofile',
                                        'change',
                                        egressProfile.id
                                      ))
                                  )
                                    $bvModal.show(
                                      `modal-base-ra-${competence.id}`
                                    );
                                }
                              "
                            >
                              <b-badge
                                class="class-badge"
                                variant="secondary"
                                >{{
                                  raBasesFiltered(competence.competence).length
                                }}</b-badge
                              >
                            </h5>
                            <b-modal
                              :id="`modal-base-ra-${competence.id}`"
                              hide-footer
                              :title="
                                $getVisibleNames(
                                  'teaching.basera',
                                  false,
                                  'RA Base'
                                )
                              "
                              size="lg"
                            >
                              <RaBase
                                :competence_id="competence.competence"
                                :can_update="can_update"
                                :can_delete="can_delete"
                              ></RaBase>
                            </b-modal>
                            <b-popover
                              :target="`ra-base-header-${competence.id}`"
                              :key="`ra-base-tooltip-${competence.id}`"
                              triggers="hover"
                            >
                              <template #title>{{
                                $getVisibleNames(
                                  "teaching.basera",
                                  false,
                                  "RA Base"
                                )
                              }}</template>
                              <template
                                v-if="
                                  raBasesFiltered(competence.competence)
                                    .length > 0
                                "
                              >
                                <div class="ra-competences-container">
                                  <span
                                    v-for="ra in raBasesFiltered(
                                      competence.competence
                                    )"
                                    :key="ra.id"
                                  >
                                    <SentenceContainer :Sentence="ra">
                                    </SentenceContainer>
                                  </span>
                                </div>
                              </template>
                              <template v-else
                                >{{ $t("matrix1.matrix1View.doesNotHaveAny") }}
                                {{
                                  $getVisibleNames(
                                    "teaching.basera",
                                    false,
                                    "RA Base"
                                  )
                                }}
                                {{ $t("matrix1.matrix1View.created") }}
                              </template>
                            </b-popover>
                          </div>
                          <ButtonSmall
                            v-if="allows_crud && can_update"
                            v-can="'mesh.change_egressprofilecompetence'"
                            :click_button="
                              () => openModalCompetenceForm(competence.id)
                            "
                            :tooltip_text="$t('reusable.common.edit')"
                            :icon="'square'"
                          ></ButtonSmall>
                          <ButtonSmall
                            v-if="allows_crud && can_delete"
                            v-can="'mesh.delete_egressprofilecompetence'"
                            :click_button="
                              () => askForDeleteCompetence(competence.id)
                            "
                            :tooltip_text="$t('reusable.common.delete')"
                            :icon="'trash'"
                          ></ButtonSmall>
                          <b-modal
                            :id="`modal-edit-competence-${competence.id}`"
                            :title="`${$t(
                              'reusable.common.edit'
                            )} ${$getVisibleNames(
                              'mesh.competence',
                              false,
                              'Competencia'
                            )}`"
                            size="lg"
                            hide-footer
                            ignore-enforce-focus-selector="#sidebar-right"
                            @hide="hideModalCompetenceForm"
                          >
                            <CompetenceForm
                              :Competence="
                                competences.find(
                                  (x) => x.id == competence.competence
                                )
                              "
                              :egress_profile_id="egress_profile_id"
                              :type_id="competence.type"
                              :cycle_id="competence.cycle"
                              @updated="
                                $bvModal.hide(
                                  `modal-edit-competence-${competence.id}`
                                )
                              "
                              @deleted="
                                $bvModal.hide(
                                  `modal-edit-competence-${competence.id}`
                                )
                              "
                              :egress_profile_view="true"
                              :can_edit_cycle="false"
                              :can_edit_profile_cycle="true"
                              :can_edit_type="true"
                              :allows_crud="true"
                              :can_update="can_update"
                              :can_delete="can_delete"
                              :show_cycle="false"
                              :show_delete_button="can_delete"
                            ></CompetenceForm>
                          </b-modal>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-td
                  :colspan="cycleList.length > 0 ? cycleList.length : 3"
                  rowspan="1"
                  v-if="
                    competenceList.filter(
                      (x) => x.type == null && x.cycle == null
                    ).length > 0
                  "
                >
                  <div
                    style="
                      background-color: var(--kl-color-accent-medium);
                      color: white;
                    "
                    class="text-center"
                  >
                    <strong>
                      {{
                        $getVisibleNames(
                          "mesh.competence",
                          true,
                          "Competencias"
                        ).toUpperCase()
                      }}
                    </strong>
                  </div>
                  <div
                    class="pl-3"
                    v-for="competence in competenceList.filter(
                      (x) => x.type == null && x.cycle == null
                    )"
                    :key="competence.id"
                  >
                    <b-row style="width: 100%; height: 100%">
                      <b-col>
                        <p>
                          <span style="position: absolute">
                            <!-- {{ competence.order }} -->
                          </span>
                          <SentenceContainer :Sentence="competence">
                            <template #order>
                              <span class="mr-2">
                                {{ competence.order }}
                              </span>
                            </template>
                          </SentenceContainer>
                        </p>
                      </b-col>
                      <b-col cols="1">
                        <div class="button-wrap">
                          <!-- v-if="competence.can_edit == user.id" -->
                          <div
                            class="mr-1"
                            v-if="institution && institution.show_base_ra"
                          >
                            <h5
                              :key="`ra-base-header-${competence.id}`"
                              :id="`ra-base-header-${competence.id}`"
                              v-bind:class="{
                                'pointer-class':
                                  allows_crud &&
                                  ([
                                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                    'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                    'DIRECTIVOS FACULTAD O ESCUELA',
                                  ].some((group) =>
                                    user.group_names.includes(group)
                                  ) ||
                                    user.is_superuser ||
                                    $hasObjectPermission(
                                      'mesh.egressprofile',
                                      'change',
                                      egressProfile.id
                                    )),
                              }"
                              @click="
                                () => {
                                  if (
                                    allows_crud &&
                                    ([
                                      'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                      'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                      'DIRECTIVOS FACULTAD O ESCUELA',
                                    ].some((group) =>
                                      user.group_names.includes(group)
                                    ) ||
                                      user.is_superuser ||
                                      $hasObjectPermission(
                                        'mesh.egressprofile',
                                        'change',
                                        egressProfile.id
                                      ))
                                  )
                                    $bvModal.show(
                                      `modal-base-ra-${competence.id}`
                                    );
                                }
                              "
                            >
                              <b-badge
                                class="class-badge"
                                variant="secondary"
                                >{{
                                  raBasesFiltered(competence.competence).length
                                }}</b-badge
                              >
                            </h5>
                            <b-modal
                              :id="`modal-base-ra-${competence.id}`"
                              hide-footer
                              :title="
                                $getVisibleNames(
                                  'teaching.basera',
                                  false,
                                  'RA Base'
                                )
                              "
                              size="lg"
                            >
                              <RaBase
                                :competence_id="competence.competence"
                                :can_update="can_update"
                                :can_delete="can_delete"
                              ></RaBase>
                            </b-modal>
                            <b-popover
                              :target="`ra-base-header-${competence.id}`"
                              :key="`ra-base-tooltip-${competence.id}`"
                              triggers="hover"
                            >
                              <template #title>{{
                                $getVisibleNames(
                                  "teaching.basera",
                                  false,
                                  "RA Base"
                                )
                              }}</template>
                              <template
                                v-if="
                                  raBasesFiltered(competence.competence)
                                    .length > 0
                                "
                              >
                                <div class="ra-competences-container">
                                  <span
                                    v-for="ra in raBasesFiltered(
                                      competence.competence
                                    )"
                                    :key="ra.id"
                                  >
                                    <SentenceContainer :Sentence="ra">
                                    </SentenceContainer>
                                  </span>
                                </div>
                              </template>
                              <template v-else
                                >{{ $t("matrix1.matrix1View.doesNotHaveAny") }}
                                {{
                                  $getVisibleNames(
                                    "teaching.basera",
                                    false,
                                    "RA Base"
                                  )
                                }}
                                {{ $t("matrix1.matrix1View.created") }}
                              </template>
                            </b-popover>
                          </div>
                          <ButtonSmall
                            v-if="allows_crud && can_update"
                            v-can="'mesh.change_egressprofilecompetence'"
                            :click_button="
                              () => openModalCompetenceForm(competence.id)
                            "
                            :tooltip_text="$t('reusable.common.edit')"
                            :icon="'square'"
                          ></ButtonSmall>
                          <ButtonSmall
                            v-if="allows_crud && can_delete"
                            v-can="'mesh.delete_egressprofilecompetence'"
                            :click_button="
                              () => askForDeleteCompetence(competence.id)
                            "
                            :tooltip_text="$t('reusable.common.delete')"
                            :icon="'trash'"
                          ></ButtonSmall>
                          <b-modal
                            :id="`modal-edit-competence-${competence.id}`"
                            :title="`${$t(
                              'reusable.common.edit'
                            )} ${$getVisibleNames(
                              'mesh.competence',
                              false,
                              'Competencia'
                            )}`"
                            size="lg"
                            hide-footer
                            ignore-enforce-focus-selector="#sidebar-right"
                            @hide="hideModalCompetenceForm"
                          >
                            <CompetenceForm
                              :Competence="
                                competences.find(
                                  (x) => x.id == competence.competence
                                )
                              "
                              :egress_profile_id="egress_profile_id"
                              :type_id="competence.type"
                              :cycle_id="competence.cycle"
                              @updated="
                                $bvModal.hide(
                                  `modal-edit-competence-${competence.id}`
                                )
                              "
                              @deleted="
                                $bvModal.hide(
                                  `modal-edit-competence-${competence.id}`
                                )
                              "
                              :can_edit_profile_cycle="true"
                              :egress_profile_view="true"
                              :can_edit_cycle="false"
                              :can_edit_type="true"
                              :allows_crud="true"
                              :can_update="can_update"
                              :can_delete="can_delete"
                              :show_cycle="false"
                              :show_delete_button="can_delete"
                            ></CompetenceForm>
                          </b-modal>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-td>
              </b-tr>
            </template>
          </template>
          <template v-else>
            <tr
              v-for="competence_type in competenceTypes"
              :key="competence_type.id"
            >
              <td
                colspan="3"
                rowspan="1"
                v-if="
                  competences_matrix.filter((x) => x.type == competence_type.id)
                    .length > 0
                "
              >
                <div
                  style="
                    background-color: var(--kl-color-accent-medium);
                    color: white;
                  "
                  class="text-center mb-1"
                >
                  <strong
                    :title="$htmlToPlainText(competence_type.description)"
                    >{{ competence_type.name.toUpperCase() }}</strong
                  >
                </div>
                <div
                  class="pl-3"
                  v-for="competence in competences_matrix.filter(
                    (x) => x.type == competence_type.id
                  )"
                  :key="competence.id"
                >
                  <b-row style="width: 100%; height: 100%">
                    <b-col>
                      <p>
                        <span style="position: absolute">
                          <!-- {{ competence.order }} -->
                        </span>
                        <SentenceContainer :Sentence="competence">
                          <template #order>
                            <span class="mr-2">
                              {{ competence.order }}
                            </span>
                          </template>
                        </SentenceContainer>
                      </p>
                    </b-col>
                    <b-col cols="1">
                      <div class="button-wrap">
                        <!-- v-if="competence.can_edit == user.id" -->
                        <div
                          class="mr-1"
                          v-if="institution && institution.show_base_ra"
                        >
                          <h5
                            :key="`ra-base-header-${competence.id}`"
                            :id="`ra-base-header-${competence.id}`"
                            v-bind:class="{
                              'pointer-class':
                                allows_crud &&
                                ([
                                  'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                  'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                  'DIRECTIVOS FACULTAD O ESCUELA',
                                ].some((group) =>
                                  user.group_names.includes(group)
                                ) ||
                                  user.is_superuser ||
                                  $hasObjectPermission(
                                    'mesh.egressprofile',
                                    'change',
                                    egressProfile.id
                                  )),
                            }"
                            @click="
                              () => {
                                if (
                                  allows_crud &&
                                  ([
                                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                    'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                    'DIRECTIVOS FACULTAD O ESCUELA',
                                  ].some((group) =>
                                    user.group_names.includes(group)
                                  ) ||
                                    user.is_superuser ||
                                    $hasObjectPermission(
                                      'mesh.egressprofile',
                                      'change',
                                      egressProfile.id
                                    ))
                                )
                                  $bvModal.show(
                                    `modal-base-ra-${competence.id}`
                                  );
                              }
                            "
                          >
                            <b-badge class="class-badge" variant="secondary">{{
                              raBasesFiltered(competence.competence).length
                            }}</b-badge>
                          </h5>
                          <b-modal
                            :id="`modal-base-ra-${competence.id}`"
                            hide-footer
                            :title="
                              $getVisibleNames(
                                'teaching.basera',
                                false,
                                'RA Base'
                              )
                            "
                            size="lg"
                          >
                            <RaBase
                              :competence_id="competence.competence"
                              :can_update="can_update"
                              :can_delete="can_delete"
                            ></RaBase>
                          </b-modal>
                          <b-popover
                            :target="`ra-base-header-${competence.id}`"
                            :key="`ra-base-tooltip-${competence.id}`"
                            triggers="hover"
                          >
                            <template #title>{{
                              $getVisibleNames(
                                "teaching.basera",
                                false,
                                "RA Base"
                              )
                            }}</template>
                            <template
                              v-if="
                                raBasesFiltered(competence.competence).length >
                                0
                              "
                            >
                              <div class="ra-competences-container">
                                <span
                                  v-for="ra in raBasesFiltered(
                                    competence.competence
                                  )"
                                  :key="ra.id"
                                >
                                  <SentenceContainer :Sentence="ra">
                                  </SentenceContainer>
                                </span>
                              </div>
                            </template>
                            <template v-else
                              >{{ $t("matrix1.matrix1View.doesNotHaveAny") }}
                              {{
                                $getVisibleNames(
                                  "teaching.basera",
                                  false,
                                  "RA Base"
                                )
                              }}
                              {{ $t("matrix1.matrix1View.created") }}
                            </template>
                          </b-popover>
                        </div>
                        <ButtonSmall
                          v-if="allows_crud && can_update"
                          v-can="'mesh.change_egressprofilecompetence'"
                          :click_button="
                            () => openModalCompetenceForm(competence.id)
                          "
                          :tooltip_text="$t('reusable.common.edit')"
                          :icon="'square'"
                        ></ButtonSmall>
                        <ButtonSmall
                          v-if="allows_crud && can_delete"
                          v-can="'mesh.delete_egressprofilecompetence'"
                          :click_button="
                            () => askForDeleteCompetence(competence.id)
                          "
                          :tooltip_text="$t('reusable.common.delete')"
                          :icon="'trash'"
                        ></ButtonSmall>
                        <b-modal
                          :id="`modal-edit-competence-${competence.id}`"
                          :title="`${$t(
                            'reusable.common.edit'
                          )} ${$getVisibleNames(
                            'mesh.competence',
                            false,
                            'Competencia'
                          )}`"
                          size="lg"
                          hide-footer
                          ignore-enforce-focus-selector="#sidebar-right"
                          @hide="hideModalCompetenceForm"
                        >
                          <CompetenceForm
                            :Competence="
                              competences.find(
                                (x) => x.id == competence.competence
                              )
                            "
                            :egress_profile_id="egress_profile_id"
                            :type_id="competence.type"
                            :cycle_id="competence.cycle"
                            @updated="
                              $bvModal.hide(
                                `modal-edit-competence-${competence.id}`
                              )
                            "
                            @deleted="
                              $bvModal.hide(
                                `modal-edit-competence-${competence.id}`
                              )
                            "
                            :egress_profile_view="true"
                            :can_edit_cycle="false"
                            :can_edit_type="true"
                            :allows_crud="true"
                            :can_update="can_update"
                            :can_delete="can_delete"
                            :show_cycle="false"
                            :show_delete_button="can_delete"
                          ></CompetenceForm>
                        </b-modal>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </td>
            </tr>
            <tr>
              <td
                colspan="3"
                rowspan="1"
                v-if="
                  competences_matrix.filter((x) => x.type == null).length > 0
                "
              >
                <div
                  style="
                    background-color: var(--kl-color-accent-medium);
                    color: white;
                  "
                  class="text-center"
                >
                  <strong>{{
                    $getVisibleNames(
                      "mesh.competence",
                      true,
                      "Competencias"
                    ).toUpperCase()
                  }}</strong>
                </div>
                <div
                  class="pl-3"
                  v-for="competence in competences_matrix.filter(
                    (x) => x.type == null
                  )"
                  :key="competence.id"
                >
                  <b-row style="width: 100%; height: 100%">
                    <b-col>
                      <p>
                        <span style="position: absolute">
                          <!-- {{ competence.order }} -->
                        </span>
                        <SentenceContainer :Sentence="competence">
                          <template #order>
                            <span class="mr-2">
                              {{ competence.order }}
                            </span>
                          </template>
                        </SentenceContainer>
                      </p>
                    </b-col>
                    <b-col cols="1">
                      <div class="button-wrap">
                        <!-- v-if="competence.can_edit == user.id" -->
                        <div
                          class="mr-1"
                          v-if="institution && institution.show_base_ra"
                        >
                          <h5
                            :key="`ra-base-header-${competence.id}`"
                            :id="`ra-base-header-${competence.id}`"
                            v-bind:class="{
                              'pointer-class':
                                allows_crud &&
                                ([
                                  'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                  'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                  'DIRECTIVOS FACULTAD O ESCUELA',
                                ].some((group) =>
                                  user.group_names.includes(group)
                                ) ||
                                  user.is_superuser ||
                                  $hasObjectPermission(
                                    'mesh.egressprofile',
                                    'change',
                                    egressProfile.id
                                  )),
                            }"
                            @click="
                              () => {
                                if (
                                  allows_crud &&
                                  ([
                                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                                    'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                                    'DIRECTIVOS FACULTAD O ESCUELA',
                                  ].some((group) =>
                                    user.group_names.includes(group)
                                  ) ||
                                    user.is_superuser ||
                                    $hasObjectPermission(
                                      'mesh.egressprofile',
                                      'change',
                                      egressProfile.id
                                    ))
                                )
                                  $bvModal.show(
                                    `modal-base-ra-${competence.id}`
                                  );
                              }
                            "
                          >
                            <b-badge class="class-badge" variant="secondary">{{
                              raBasesFiltered(competence.competence).length
                            }}</b-badge>
                          </h5>
                          <b-modal
                            :id="`modal-base-ra-${competence.id}`"
                            hide-footer
                            :title="
                              $getVisibleNames(
                                'teaching.basera',
                                false,
                                'RA Base'
                              )
                            "
                            size="lg"
                          >
                            <RaBase
                              :competence_id="competence.competence"
                              :can_update="can_update"
                              :can_delete="can_delete"
                            ></RaBase>
                          </b-modal>
                          <b-popover
                            :target="`ra-base-header-${competence.id}`"
                            :key="`ra-base-tooltip-${competence.id}`"
                            triggers="hover"
                          >
                            <template #title>{{
                              $getVisibleNames(
                                "teaching.basera",
                                false,
                                "RA Base"
                              )
                            }}</template>
                            <template
                              v-if="
                                raBasesFiltered(competence.competence).length >
                                0
                              "
                            >
                              <div class="ra-competences-container">
                                <span
                                  v-for="ra in raBasesFiltered(
                                    competence.competence
                                  )"
                                  :key="ra.id"
                                >
                                  <SentenceContainer
                                    :unique_id="
                                      competence.competence +
                                      '-' +
                                      ra.id +
                                      '-' +
                                      ra.full_sentence
                                    "
                                    :Sentence="ra"
                                  >
                                  </SentenceContainer>
                                </span>
                              </div>
                            </template>
                            <template v-else
                              >{{ $t("matrix1.matrix1View.doesNotHaveAny") }}
                              {{
                                $getVisibleNames(
                                  "teaching.basera",
                                  false,
                                  "RA Base"
                                )
                              }}
                              {{ $t("matrix1.matrix1View.created") }}
                            </template>
                          </b-popover>
                        </div>
                        <ButtonSmall
                          v-if="allows_crud && can_update"
                          v-can="'mesh.change_egressprofilecompetence'"
                          :click_button="
                            () => openModalCompetenceForm(competence.id)
                          "
                          :tooltip_text="$t('reusable.common.edit')"
                          :icon="'square'"
                        ></ButtonSmall>
                        <ButtonSmall
                          v-if="allows_crud && can_delete"
                          v-can="'mesh.delete_egressprofilecompetence'"
                          :click_button="
                            () => askForDeleteCompetence(competence.id)
                          "
                          :tooltip_text="$t('reusable.common.delete')"
                          :icon="'trash'"
                        ></ButtonSmall>
                        <b-modal
                          :id="`modal-edit-competence-${competence.id}`"
                          :title="`${$t(
                            'reusable.common.edit'
                          )} ${$getVisibleNames(
                            'mesh.competence',
                            false,
                            'Competencia'
                          )}`"
                          size="lg"
                          hide-footer
                          ignore-enforce-focus-selector="#sidebar-right"
                          @hide="hideModalCompetenceForm"
                        >
                          <CompetenceForm
                            :Competence="
                              competences.find(
                                (x) => x.id == competence.competence
                              )
                            "
                            :egress_profile_id="egress_profile_id"
                            :type_id="competence.type"
                            :cycle_id="competence.cycle"
                            @updated="
                              $bvModal.hide(
                                `modal-edit-competence-${competence.id}`
                              )
                            "
                            @deleted="
                              $bvModal.hide(
                                `modal-edit-competence-${competence.id}`
                              )
                            "
                            :egress_profile_view="true"
                            :can_edit_cycle="false"
                            :can_edit_type="true"
                            :allows_crud="true"
                            :can_update="can_update"
                            :can_delete="can_delete"
                            :show_cycle="false"
                            :show_delete_button="can_delete"
                          ></CompetenceForm>
                        </b-modal>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </td>
            </tr>
          </template>
        </template>
      </b-tbody>
    </b-table-simple>
    <div class="empty-text" v-if="competenceList.length == 0">
      {{ $t("matrix1.matrix1View.noData") }}
      {{ $getVisibleNames("mesh.competence", true, "Competencias") }}
      {{ $t("matrix1.matrix1View.associatedToThisProfile") }}.
    </div>

    <div>
      <b-modal
        id="modal"
        :title="`${$t('matrix1.matrix1View.draft')} ${$getVisibleNames(
          'mesh.competence',
          false,
          'Competencia'
        )}`"
        size="xl"
        :hide-footer="true"
        ref="competence_modal"
        ignore-enforce-focus-selector="#sidebar-right"
        @hide="hideModalCompetenceForm"
      >
        <CompetenceForm
          v-if="competence_in_proccess"
          :Competence="
            !isNaN(competence_in_proccess.id)
              ? competences.find(
                  (x) => x.id == competence_in_proccess.competence
                )
              : null
          "
          :type_id="competence_in_proccess.type"
          :cycle_id="competence_in_proccess.cycle"
          :order="competence_in_proccess.order"
          :sub_order="competence_in_proccess.sub_order"
          :egress_profile_id="egress_profile_id"
          @updated="slotUpdatedCompetence"
          @created="slotUpdatedCompetence"
          @created_egress_profile_competence="normalizeSubOrders"
          @deleted="slotDeletedFromModal"
          :egress_profile_view="true"
          :can_edit_type="canEditTypeInModal"
          :can_edit_cycle="false"
          :can_edit_profile_cycle="true"
          :can_edit_order="true"
          :can_update="can_update"
          :can_delete="can_delete"
          :allows_crud="allows_crud && can_update"
          :matrix1_competence="true"
          :show_delete_button="can_delete"
        ></CompetenceForm>
      </b-modal>
      <b-modal
        id="select-competence-matrix1-modal"
        :title="`${$t('reusable.common.selectLabel')} ${$getVisibleNames(
          'mesh.competence',
          true,
          'Competencias'
        )}`"
        size="xl"
        @hide="hideSelectCompetenceModal"
        hide-footer
      >
        <SelectedCompetence
          v-if="select_competence_context"
          :egress_profile_id="egress_profile_id"
          :cycle_id="select_competence_context.cycle"
          :display_id="`select-competence-matrix1-modal`"
          @slotUpdate="slotUpdateProfileCompetence"
          :selected_competence_matrix="true"
          :default_order="select_competence_context.order"
          :default_sub_order="select_competence_context.sub_order"
          :disable_cycle_select="true"
          :precursor_egress_profile_competence_id="
            select_competence_context.egress_profile_competence_id
          "
        ></SelectedCompetence>
        <div class="row">
          <div class="col" style="text-align: right">
            <b-button
              class="mr-1"
              @click="saveSelectedProfileCompetence()"
              size="sm"
            >
              {{ $t("reusable.common.save") }}
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { generateUniqueId, toast } from "@/utils/utils";

export default {
  name: "Matrix1",
  components: {
    RaBase: () => import("@/components/reusable/RaBase"),
    CompetenceForm: () =>
      import("../CurricularResources/Competence/CompetenceForm"),
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    SelectedCompetence: () =>
      import("@/components/mesh/EgressProfile/SelectedCompetence"),
  },
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      competences_matrix: [],
      competence_in_proccess: null,
      // Celda (ciclo + order) y sub_order que tenía la competencia al abrir el
      // formulario de edición; se usa para reordenar origen y destino al guardar.
      editing_origin: null,
      select_competence_context: null,
      selected_competences: {},
      competence_precursors: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      // user_position: names.USER_POSITION,
      institution: "getInstitution",
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      faculties: names.FACULTIES,
      ra_bases: names.RA_BASES,
      competenceTypes: names.COMPETENCE_TYPES,
      profile_competences: names.PROFILE_COMPETENCES,
      profile_cycles: names.PROFILE_CYCLES,
      cycles: names.CYCLES,
      competences: names.COMPETENCES,
      taxonomy: names.TAXONOMY,
    }),
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    faculty() {
      if (!this.career) return null;
      return this.faculties.find((x) => x.id == this.career.faculty);
    },
    egressProfileCycleId() {
      if (!this.egress_profile_id) return [];
      let list = [];
      this.profile_cycles.forEach((x) => {
        if (x.egress_profile == this.egress_profile_id) list.push(x.cycle);
      });
      return list;
    },
    egressProfileCycleSort() {
      if (!this.egressProfile) return [];
      let cycles = this.cycles.filter((x) =>
        this.egressProfileCycleId.includes(x.id)
      );
      cycles.forEach((x) => {
        let cycle_list = this.profile_cycles.find(
          (profile_cycle) =>
            profile_cycle.cycle == x.id &&
            profile_cycle.egress_profile == this.egress_profile_id
        );
        if (cycle_list) {
          x.init_semester = cycle_list.init_semester;
          x.end_semester = cycle_list.end_semester;
          x.order = cycle_list.order;
        }
      });
      return cycles.sort(function (a, b) {
        if (a.init_semester < b.init_semester) return -1;
        if (a.init_semester > b.init_semester) return 1;
        if (a.end_semester < b.end_semester) return -1;
        if (a.end_semester > b.end_semester) return 1;
        return 0;
      });
    },
    // competenceList() {
    //   return this.competences.filter(
    //     (x) => x.egress_profile == this.egress_profile_id
    //   );
    // },
    competenceList() {
      let list = [];
      if (!this.egressProfile) return [];
      let competences = [];
      if (this.egressProfileCycleSort.length > 0) {
        competences = this.profile_competences.filter(
          (x) =>
            (x.egress_profile == this.egress_profile_id &&
              this.egressProfileCycleId.includes(x.cycle)) ||
            (x.egress_profile == this.egress_profile_id && x.cycle == null)
        );
      } else {
        competences = this.profile_competences.filter(
          (x) => x.egress_profile == this.egress_profile_id && x.cycle == null
        );
      }
      competences.forEach((competence) => {
        if (competence) {
          let get_competence = this.competences.find(
            (x) => x.id == competence.competence
          );
          if (get_competence && this.taxonomy) {
            let get_verb = null;
            this.taxonomy.cognitive_levels.forEach((cl) => {
              if (cl.verbs.find((x) => x.id == get_competence.verb)) {
                get_verb = cl.verbs.find((x) => x.id == get_competence.verb);
              }
            });
            list.push({
              id: competence.id,
              competence: competence.competence,
              order: competence.order,
              sub_order: competence.sub_order,
              egress_profile: competence.egress_profile,
              cycle: competence.cycle,
              action: get_competence.action,
              content: get_competence.content,
              condition: get_competence.condition,
              context: get_competence.context,
              full_sentence: get_competence.full_sentence,
              // can_edit: get_competence.created_by,
              type: get_competence.type,
              verb: get_competence.verb,
              sentence: get_competence.sentence,
              name: get_competence.name,
              cognitive_level: get_verb ? get_verb.cognitive_level : 0,
            });
          }
        }
      });
      return list.sort(function (a, b) {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        if (a.sub_order < b.sub_order) return -1;
        if (a.sub_order > b.sub_order) return 1;
        return 0;
      });
    },
    // Versión en el store de la competencia abierta en el formulario de edición.
    // Se observa aquí porque el modal se cierra (y destruye el formulario) antes
    // de que termine el PUT, así que el evento del formulario no llega.
    editingProfileCompetence() {
      if (!this.editing_origin) return null;
      return (
        this.profile_competences.find(
          (x) => x.id == this.editing_origin.id
        ) || null
      );
    },
    cycleList() {
      let list = [];
      if (!this.egressProfile) return list;
      this.egressProfileCycleId.forEach((cycle_id) => {
        const cycle = this.cycles.find((x) => x.id == cycle_id);
        if (cycle) list.push(cycle);
      });
      return list;
    },
    // Determina si el tipo de competencia puede editarse en el modal de creación/edición.
    // Si hay ciclos definidos, el tipo debe coincidir con las demás competencias del mismo
    // orden en la fila. Solo se permite editar si la competencia ya tiene un tipo distinto
    // al del resto (inconsistencia existente que se debe poder corregir).
    canEditTypeInModal() {
      if (this.egressProfileCycleSort.length === 0) return true;
      if (!this.competence_in_proccess) return true;

      const currentType = this.competence_in_proccess.type;
      const order = this.competence_in_proccess.order;
      const currentCycle = this.competence_in_proccess.cycle;

      // Si la competencia pertenece al ciclo final, se permite editar el tipo
      const finalCycle =
        this.egressProfileCycleSort[this.egressProfileCycleSort.length - 1];
      if (finalCycle && currentCycle === finalCycle.id) return true;

      // Buscar competencias reales en la misma fila (mismo orden, ciclo distinto),
      // incluyendo las que tienen tipo null (también sirven como referencia para restringir)
      const siblings = this.competenceList.filter(
        (x) =>
          x.order === order &&
          x.egress_profile === this.egress_profile_id &&
          x.cycle !== currentCycle &&
          x.cycle != null
      );

      // Sin hermanas en la fila, se permite editar libremente
      if (siblings.length === 0) return true;

      // Si el tipo actual ya difiere del tipo de las hermanas, permitir edición para corregir
      const siblingType = siblings[0].type;
      if (currentType !== siblingType) return true;

      // Tipo coincide con las hermanas → bloquear para mantener consistencia
      return false;
    },
  },
  methods: {
    fetchCompetencePrecursors() {
      this.$restful
        .Get(
          `/mesh/check_if_egress_profile_has_competence_precursors/?egress_profile=${this.egress_profile_id}`
        )
        .then((response) => {
          this.competence_precursors = response;
        });
    },
    openModalCompetenceForm(competence_id) {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$nextTick(() => {
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          egress_profile_id: this.egress_profile_id,
          intelligence_option: 1,
        });
        this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
          visible_intelligence_options: [1],
          disabled_selected_egress_profile: true,
        });
      });
      this.$bvModal.show(`modal-edit-competence-${competence_id}`);
    },
    lastCompetence(order, cycle_id) {
      const actual_cycle = this.egressProfileCycleSort.find(
        (x) => x.id == cycle_id
      );
      if (!actual_cycle) return null;
      const last_cycle = this.egressProfileCycleSort.find(
        (x) => x.order == actual_cycle.order + 1
      );
      if (!last_cycle) return null;
      const last_competence = this.competenceList.find(
        (x) =>
          x.order == order &&
          x.cycle == last_cycle.id &&
          x.egress_profile == this.egress_profile_id
      );
      if (!last_competence) return null;
      last_competence.cycle_order = last_cycle.order;
      return last_competence;
    },
    actualCycle(cycle_id) {
      const actual_cycle = this.egressProfileCycleSort.find(
        (x) => x.id == cycle_id
      );
      return actual_cycle;
    },
    openModalCompetenceCycle(competence_in_progress) {
      const last_competence = this.lastCompetence(
        competence_in_progress.order,
        competence_in_progress.cycle
      );
      const actual_cycle = this.actualCycle(competence_in_progress.cycle);

      if (last_competence && actual_cycle) {
        let competence_order = last_competence.order;
        if (
          last_competence.sub_order > 0 &&
          this.institution &&
          this.institution.show_competence_sub_order
        )
          competence_order += "." + last_competence.sub_order;
        this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
        this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            egress_profile_id: this.egress_profile_id,
            competence_id: last_competence.competence,
            order: competence_order,
            cycle_order: last_competence.cycle_order,
            cycle_id: last_competence.cycle,
            name_cycle_actual: actual_cycle.name,
            extra_label: `${this.$getVisibleNames(
              "mesh.competence",
              false,
              "Competencia"
            )} por ${this.$getVisibleNames(
              "mesh.cycle",
              false,
              "Ciclo Formativo"
            )}`,
            intelligence_option: 8,
            sub_option: 5,
          });
          this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
            visible_intelligence_options: [8],
            disabled_selected_intelligence_option: true,
            disabled_selected_competence: true,
            disabled_selected_cycle: true,
          });
        });
      }
    },
    hideModalCompetenceForm() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$nextTick(() => {
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          egress_profile_id: this.egress_profile_id,
          intelligence_option: 1,
        });
        this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
          visible_intelligence_options: [1],
          disabled_selected_egress_profile: true,
        });
      });
    },
    slotUpdatedCompetence(item) {
      this.competence_in_proccess = item;
      this.$refs.competence_modal.hide();
      this.$bvModal.hide("modal");
      this.fetchCompetencePrecursors();
    },
    raBasesFiltered(comptence_id) {
      if (!comptence_id) return [];
      return this.ra_bases
        .filter((x) => x.competences.includes(comptence_id))
        .sort((a, b) => a.order - b.order);
    },
    askForUpdateCompetence(row_competence) {
      this.competence_in_proccess = row_competence;
      this.editing_origin = !isNaN(row_competence.id)
        ? {
            id: row_competence.id,
            egress_profile: row_competence.egress_profile,
            cycle: row_competence.cycle,
            order: row_competence.order,
            sub_order: row_competence.sub_order,
          }
        : null;
      this.$refs.competence_modal.show();
      this.openModalCompetenceCycle(row_competence);
    },
    openSelectCompetenceModal(context) {
      this.select_competence_context = context;
      this.selected_competences = {};
      this.$store.dispatch(names.FETCH_COMPETENCES).then(() => {
        this.$bvModal.show("select-competence-matrix1-modal");
      });
    },
    hideSelectCompetenceModal() {
      this.select_competence_context = null;
      this.selected_competences = {};
    },
    slotUpdateProfileCompetence(competence_selections) {
      this.selected_competences = competence_selections;
    },
    saveSelectedProfileCompetence() {
      if (!this.select_competence_context) return;
      const competence_ids = Object.keys(this.selected_competences);
      if (competence_ids.length == 0) {
        this.$swal.fire(
          this.$t("reusable.common.warning"),
          this.$t("reusable.common.mustSelectedAtLeast", {
            min: 1,
            entity: this.$getVisibleNames(
              "mesh.competence",
              false,
              "Competencia"
            ),
          }),
          "warning"
        );
        return;
      }
      const promises = competence_ids.map((competence_id) => {
        const selection = this.selected_competences[competence_id];
        return this.$store
          .dispatch(names.POST_PROFILE_COMPETENCE, {
            egress_profile: this.select_competence_context.egress_profile,
            competence: parseInt(competence_id),
            cycle: this.select_competence_context.cycle,
            order: selection.order,
            sub_order: selection.sub_order,
            capacities: [],
          })
          .then((profile_competence) => {
            this.reorganizeSubOrders(profile_competence);
          });
      });
      // Se espera que terminen todos los POST y luego se realiza el fetch
      // para saber si existen competencias apra seleccionar
      Promise.all(promises).then(() => {
        this.fetchCompetencePrecursors();
      });
      this.$bvModal.hide("select-competence-matrix1-modal");
    },
    // Verifica si la competencia en `cell_index` tiene un nivel cognitivo superior
    // al de alguna competencia de un ciclo posterior en la misma fila (mismo orden).
    // Retorna true si se detecta una inconsistencia, para mostrar la alerta en el tooltip.
    competenceCognitiveLevel(cell_index, row) {
      const currentLevel = row[cell_index]?.cognitive_level;
      // Si la celda actual no tiene nivel cognitivo asignado, no hay nada que comparar
      if (currentLevel == null) return false;

      for (let i = cell_index + 1; i < row.length; i++) {
        const nextLevel = row[i]?.cognitive_level;
        // Solo comparar si el ciclo posterior también tiene nivel cognitivo asignado
        if (nextLevel != null && currentLevel > nextLevel) {
          return true;
        }
      }
      return false;
    },
    askForDeleteCompetence(id) {
      this.$swal({
        title: this.$t(
          "matrix1.matrix1View.deleteCompetenceAssociationConfirm",
          {
            competence: this.$getVisibleNames(
              "mesh.competence",
              false,
              "Competencia"
            ),
            egressProfile: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ),
          }
        ),
        text: this.$t("matrix1.matrix1View.deleteActionIrreversible"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) this.deleteCompetence(id);
      });
    },
    deleteCompetence(id) {
      const deleted = this.profile_competences.find((x) => x.id == id);
      this.$store.dispatch(names.DELETE_PROFILE_COMPETENCE, id).then(() => {
        if (deleted) this.compactCell(deleted);
        toast(
          String(
            this.$getVisibleNames("mesh.competence", false, "Competencia") +
              " " +
              this.$t("reusable.common.deleted")
          )
        );
        if (this.egressProfileCycleSort.length > 0) {
          this.fetchCompetencePrecursors();
        }
      });
    },
    competencesMatrix() {
      if (!this.egressProfile && !this.egressProfileCycleSort) return [];
      let max_level = 1;
      this.competenceList.forEach((element) => {
        if (element.order > max_level && element.cycle) {
          max_level = element.order;
        }
      });
      let matrix = [];
      if (this.egressProfileCycleSort.length > 0) {
        for (var i = 0; i < max_level; i++) {
          matrix[i] = [];
          for (var j = 0; j < this.egressProfileCycleSort.length; j++) {
            matrix[i][j] = {
              id: generateUniqueId(),
              egress_profile: this.egress_profile_id,
              action: "",
              content: "",
              condition: "",
              sentence: "",
              cycle: this.egressProfileCycleSort[j].id,
              // can_edit: null,
              order: i + 1,
              type: 1,
            };
          }
        }
        this.competenceList.forEach((competence) => {
          try {
            if (competence.cycle != null) {
              let cycle = this.findCycle(competence.cycle);
              if (cycle)
                matrix[competence.order - 1][cycle.order - 1] = competence;
              matrix[competence.order - 1].forEach((element) => {
                if (isNaN(element.id)) {
                  element.type = competence.type;
                }
              });
            }
          } catch (error) {
            console.log("Error contruyendo Matriz de competencias. ", error);
          }
        });
      } else {
        matrix = this.competenceList.filter((x) => x.cycle == null);
      }
      this.competences_matrix = matrix;
    },
    findCycle(id) {
      let c = null;
      this.cycles.forEach((cycle) => {
        if (cycle.id == id) {
          c = cycle;
          return cycle;
        }
      });
      return c;
    },
    getNextSubOrder(egress_profile_id, order, cycle_id) {
      // Obtener todas las competencias con el mismo order, cycle y egress_profile
      const competencesWithSameOrder = this.profile_competences.filter(
        (x) =>
          x.egress_profile == egress_profile_id &&
          x.order == order &&
          x.cycle == cycle_id
      );

      // Si no hay competencias, retornar 0 (primera competencia no usa sub_order)
      if (competencesWithSameOrder.length === 0) return 0;

      // Si hay 1 competencia, la segunda será sub_order: 2
      // (la primera se reorganizará a 1 automáticamente)
      if (competencesWithSameOrder.length === 1) return 2;

      // Si hay 2 o más competencias, retornar el siguiente número
      return competencesWithSameOrder.length + 1;
    },
    // Competencias de una celda (perfil + ciclo + order), ordenadas por sub_order.
    cellCompetences(egress_profile_id, cycle_id, order, exclude_id = null) {
      return this.profile_competences
        .filter(
          (x) =>
            x.egress_profile == egress_profile_id &&
            x.cycle == cycle_id &&
            x.order == order &&
            x.id != exclude_id
        )
        .sort((a, b) => a.sub_order - b.sub_order || a.id - b.id);
    },
    // Asigna sub_order consecutivos (1..n) según la posición en `list`. Si la
    // celda queda con una sola competencia vuelve a 0 (sin sub_order visible).
    applySubOrders(list) {
      list.forEach((comp, index) => {
        const sub_order = list.length == 1 ? 0 : index + 1;
        if (comp.sub_order != sub_order)
          this.$store.dispatch(names.PATCH_PROFILE_COMPETENCE, {
            profile_competence_id: comp.id,
            item: { sub_order: sub_order },
          });
      });
    },
    // Cierra el hueco que deja una competencia que salió de su celda.
    compactCell(cell) {
      this.applySubOrders(
        this.cellCompetences(cell.egress_profile, cell.cycle, cell.order, cell.id)
      );
    },
    // Tras crear/editar desde el formulario:
    // - Si cambió de celda (otro order), se agrega al final de la celda destino
    //   y se renumera la celda de origen para no dejar huecos.
    // - Si sigue en la misma celda y cambió el sub_order, se inserta en esa
    //   posición y se corren las demás.
    normalizeSubOrders(profile_competence) {
      if (!profile_competence || isNaN(profile_competence.id)) return;
      const competence =
        this.profile_competences.find((x) => x.id == profile_competence.id) ||
        profile_competence;
      const origin =
        this.editing_origin && this.editing_origin.id == competence.id
          ? this.editing_origin
          : null;
      const target = this.cellCompetences(
        competence.egress_profile,
        competence.cycle,
        competence.order,
        competence.id
      );
      if (
        origin &&
        origin.cycle == competence.cycle &&
        origin.order == competence.order
      ) {
        if (origin.sub_order == competence.sub_order) return;
        const position = Math.min(
          Math.max(parseInt(competence.sub_order, 10) - 1, 0),
          target.length
        );
        target.splice(position, 0, competence);
      } else {
        target.push(competence);
        if (origin) this.compactCell(origin);
      }
      this.applySubOrders(target);
      this.editing_origin = null;
    },
    slotDeletedFromModal() {
      if (this.editing_origin) this.compactCell(this.editing_origin);
      this.editing_origin = null;
      this.$bvModal.hide("modal");
    },
    reorganizeSubOrders(profile_competence) {
      // Verificar que tenemos los datos necesarios
      if (!profile_competence || !profile_competence.egress_profile) {
        return;
      }

      const egress_profile_id = profile_competence.egress_profile;
      const order = profile_competence.order;
      const cycle_id = profile_competence.cycle;

      // Obtener todas las profile_competences con el mismo order, cycle y egress_profile
      const competencesWithSameOrder = this.profile_competences.filter(
        (x) =>
          x.egress_profile == egress_profile_id &&
          x.order == order &&
          x.cycle == cycle_id
      );

      // SOLO reorganizar cuando hay exactamente 2 competencias
      // (es decir, acabamos de crear la segunda)
      if (competencesWithSameOrder.length !== 2) return;

      // Verificar si la primera competencia tiene sub_order null o 0
      const firstCompetence = competencesWithSameOrder.find(
        (comp) => comp.id !== profile_competence.id
      );

      if (
        firstCompetence &&
        (firstCompetence.sub_order === null || firstCompetence.sub_order === 0)
      ) {
        // Ordenar las competencias por ID para mantener el orden de creación
        const sortedCompetences = competencesWithSameOrder.sort((a, b) => {
          return a.id - b.id;
        });

        // Reasignar sub_orders empezando desde 1
        sortedCompetences.forEach((comp, index) => {
          const newSubOrder = index + 1;
          if (comp.sub_order !== newSubOrder) {
            // Actualizar el sub_order en el backend
            const payload = {
              id: comp.id,
              egress_profile: comp.egress_profile,
              competence: comp.competence,
              order: comp.order,
              sub_order: newSubOrder,
              cycle: comp.cycle,
            };
            this.$store.dispatch(names.UPDATE_PROFILE_COMPETENCE, payload);
          }
        });
      }
    },
  },
  watch: {
    competenceList: function () {
      this.competencesMatrix();
    },
    editingProfileCompetence(profile_competence) {
      const origin = this.editing_origin;
      if (!origin || !profile_competence) return;
      if (
        profile_competence.cycle == origin.cycle &&
        profile_competence.order == origin.order &&
        profile_competence.sub_order == origin.sub_order
      )
        return;
      this.normalizeSubOrders(profile_competence);
    },
    "career.id": function () {
      if (this.faculties.findIndex((x) => x.id == this.career.faculty) == -1)
        this.$store.dispatch(names.FETCH_FACULTY, this.career.faculty);
    },
  },
  created() {
    // console.log("Matriz 1 created...");
    // if (
    //   this.egressProfiles.findIndex((x) => x.id == this.egress_profile_id) == -1
    // )
    this.$store
      .dispatch(names.FETCH_CYCLES, this.egress_profile_id)
      .then(() => {
        this.competencesMatrix();
      });
    this.fetchCompetencePrecursors();
  },
  beforeDestroy() {},
  mounted() {
    this.competencesMatrix();
  },
};
</script>

<style scoped>
.class-badge {
  width: 30px;
  /* Badge de conteo alineado al chip suave del estándar (celeste + texto azul). */
  background: var(--kl-chip-bg) !important;
  color: var(--kl-chip-text) !important;
  border: 1px solid var(--kl-chip-border) !important;
  border-radius: var(--kl-radius-pill) !important;
  font-weight: var(--kl-chip-fw);
}
th {
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-weight: var(--kl-fw-bold);
}
table,
th,
td {
  border: 1px solid var(--kl-table-border);
  position: relative;
}
td.cycle-cell {
  height: 1px;
}
td.cycle-cell > div {
  display: flex;
  flex-direction: column;
  height: 100%;
}
td.cycle-cell div.float-button {
  display: flex;
  justify-content: center;
  margin-top: auto;
}
p {
  font-size: 16px !important;
}
.caption {
  font-size: 17px;
}
.cognitive-level-tooltip {
  text-align: justify !important;
  padding-left: 4px;
}
.empty-text {
  background: var(--kl-surface-muted);
  margin: auto;
  padding: 0.2em 1em;
  width: 65vh;
  border-radius: var(--kl-radius-md);
  font-weight: var(--kl-fw-semibold);
}
.pointer-class {
  cursor: pointer;
}
.button-wrap {
  display: flex;
}
.ra-competences-container {
  max-height: 500px;
  overflow-y: auto;
}
.info-icon {
  position: relative;
  vertical-align: top;
  height: 12px;
  width: 12px;
}
@media print {
  .badge {
    border: none;
  }
}
</style>